<template>
  <div class="expand-page">
    <Table
      class="expand-table-child"
      :show-header="false"
      style="border:0"
      ref="selection"
      :columns="columns4"
      :data="rows"
    >
      <template slot-scope="{ row }" slot="action">
        <div style="text-align:right;padding-right:7px;">
          <Button @click="editClassify(row)" type="text" size="small">编辑</Button>-
          <Button @click="deleteClassify(row)" type="text" size="small">删除</Button>
        </div>
      </template>
    </Table>
    <!-- <Modal v-model="addClassifyModal" :title="modalText" ref="modal">
      <div class="course-type">
        <Form :rules="ruleValidate" :model="addClassifyInfo" :label-width="80">
          <FormItem v-if="addClassifyInfo.parent_id != 0" label="所属分类">
            <p>{{addClassifyInfo.title}}</p>
          </FormItem>
          <FormItem label="分类名称" prop="name">
            <Input style="width:300px" type="text" v-model="addClassifyInfo.name" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="addClassifyModal = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>-->
  </div>
</template>
<script>
export default {
  props: {
    row: Object
  },
  data() {
    return {
      columns4: [
        {
          type: "expand",
          align: "center",
          minWidth: 40
        },
        {
          title: "分类名称",
          key: "name",
          minWidth: 120
        },
        {
          title: "课程数量",
          key: "course_num",
          minWidth: 340
        },
        {
          title: "操作",
          slot: "action",
          key: "address",
          minWidth: 140,
          fixed: "right"
        }
      ],
      ruleValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      },
      addClassifyModal: false,
      modalText: "新增分类",
      addClassifyInfo: {}
    };
  },
  mounted() {},
  computed: {
    rows() {
      this.row.children.forEach(i => {
        i._disableExpand = true;
      });
      return this.row.children;
    }
  },
  methods: {
    addClassify(row) {
      if (row) {
        this.addClassifyInfo = JSON.parse(JSON.stringify(row));
      }
      this.modalText = "新增分类";
      this.addClassifyModal = true;
    },
    deleteClassify(row) {
      this.$emit("onDelete", row);
    },
    editClassify(row) {
      this.$emit("onEdit", row);
    }
  }
};
</script>
<style>
#courseCenter .ivu-table-expanded-cell {
  padding: 0 !important;
}
</style>
